// extracted by mini-css-extract-plugin
module.exports = {"container":"project-list-item-details_container__2vUxH","left":"project-list-item-details_left__26XvU","right":"project-list-item-details_right__2KxV6"};